// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3X5Cr","author":"Table_author__SHWu0","authorImage":"Table_authorImage__hsHcL","unreadRow":"Table_unreadRow__3o9ib"};